import React from 'react'

import { Helmet } from 'react-helmet'

import NavbarInteractive from '../components/navbar-interactive'
import Footer from '../components/footer'
import './gleiwitz.css'

const Gleiwitz = (props) => {
  return (
    <div className="gleiwitz-container1">
      <Helmet>
        <title>Begin Tweede Wereldoorlog - marjangerrits.nl</title>
        <meta
          name="description"
          content="Blog over begin Tweede Wereldoorlog"
        />
        <meta property="og:title" content="Begin Tweede Wereldoorlog" />
        <meta
          property="og:description"
          content="Blog over begin Tweede Wereldoorlog"
        />
      </Helmet>
      <NavbarInteractive rootClassName="navbar-interactiveroot-class-name19"></NavbarInteractive>
      <div className="gleiwitz-blogtitel-en-datum">
        <div className="gleiwitz-container2">
          <h1 className="gleiwitz-titel BlogTitel">Echt nep</h1>
        </div>
      </div>
      <div className="gleiwitz-container3">
        <p className="gleiwitz-datum">
          <span>08-10-2024</span>
          <br></br>
        </p>
        <img
          alt="image"
          src="/Blog foto's/gliwice_drewniana_wieza_radiostacji-1500h.jpg"
          className="gleiwitz-foto"
        />
        <span className="gleiwitz-tekst">
          <span className="Schuingedrukt_tekst">
            Foto:
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <span className="Schuingedrukt_tekst">
            de radiotoren van Gleiwitz - 
          </span>
          <span className="Schuingedrukt_tekst">
            https://nl.wikipedia.org/wiki/Radiotoren_van_Gleiwitz
          </span>
          <br className="Schuingedrukt_tekst"></br>
          <span className="Schuingedrukt_tekst">Andrzej Jarczewski</span>
          <br className="Schuingedrukt_tekst"></br>
          <br className="Schuingedrukt_tekst"></br>
          <span className="Dikgedrukt_tekst">Echt nep, the</span>
          <span className="Dikgedrukt_tekst">ma M</span>
          <span className="Dikgedrukt_tekst">
            aand van de Geschiedenis 2024
          </span>
          <br></br>
          <br></br>
          <span>
            Mijn dubbelroman over de Tweede Wereldoorlog, die nu door de
            redacteur wordt geredigeerd, gaat niet alleen over de ontberingen
            van een Nederlander, maar laat ook de andere kant zien. Hoe was het
            voor een Duitse jongen in die tijd?
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span>
            Hieronder een stukje tekst uit mijn manuscript. Het past goed in de
            Maand van de Geschiedenis met dit jaar als thema ‘Echt nep’. In de
            oorlog was veel echt nep, daar ben ik tijdens mijn onderzoek wel
            achter gekomen.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span className="Schuingedrukt_tekst">‘</span>
          <span className="Schuingedrukt_tekst">
            Polen is de oorlog begonnen!’ Een buurvrouw rent de bakkerij in.
            Bakker Borchelt doet de radio aan als Hitler zijn rede voor de
            Rijksdag begint. Het is 1 september 1939, even na tien uur in de
            ochtend en de stem van de Führer schalt over de versgebakken broden.
            Ze horen dat Polen de radiotoren in Gleiwitz aangevallen heeft.
          </span>
          <br className="gleiwitz-text32"></br>
          <br className="gleiwitz-text33"></br>
          <span className="Schuingedrukt_tekst">
            Mevrouw Borchelt komt met koffie binnen en gaat bij hen zitten. Stil
            luisteren ze naar Hitlers uitleg. Over de vele grensconflicten met
            Polen, dat Polen niet wil onderhandelen, dat Duitsland verschillende
            voorstellen heeft gedaan, alles heeft geprobeerd. Dat, na deze
            aanval op hun grondgebied, Duitsland moet reageren en niet over zich
            heen zal laten lopen.
          </span>
          <br></br>
          <br></br>
          <span className="Dikgedrukt_tekst">
            Over het Gleiwitz-incident: hoe de nazi’s de oorlog begonnen
          </span>
          <br></br>
          <br></br>
          <span>
            Op 31 augustus 1939 werd het radiostation in Gleiwitz, dicht bij de
            grens met Polen, aangevallen door een groep Duitsers, verkleed in
            Poolse uniformen. Ze overmeesterden de medewerkers van het
            radiostation en zonden een kort bericht uit in het Pools, waarin ze
            beweerden dat de aanval door Poolse troepen werd uitgevoerd. Om het
            geloofwaardiger te maken, gebruikten de nazi&apos;s een Duitse
            gevangene van Poolse afkomst. Ze vermoordden hem en lieten zijn
            lichaam achter bij het radiostation, zodat het leek alsof een Poolse
            soldaat bij de aanval betrokken was.
          </span>
          <br></br>
          <br></br>
          <span>
            De volgende dag, op 1 september 1939, gebruikte Adolf Hitler dit
            incident als een excuus om Polen binnen te vallen. Hij beweerde dat
            Duitsland zich moest verdedigen tegen de Poolse aanvallen. Twee
            dagen later verklaarden Groot-Brittannië en Frankrijk de oorlog aan
            Duitsland. Zij hadden beloofd Polen te helpen als het zou worden
            aangevallen. De Tweede Wereldoorlog was een feit.
            <span
              dangerouslySetInnerHTML={{
                __html: ' ',
              }}
            />
          </span>
          <br></br>
          <br></br>
          <span>
            Echt nep dus. Mijn hoofdpersoon geloofde wat er verteld werd, hij
            had geen reden eraan te twijfelen. Echt nep is van alle tijden, maar
            nu met alle nieuwe technologie lijkt het erger dan ooit. Hoe weet
            jij nog wat waar is?
          </span>
          <br></br>
          <br></br>
          <br></br>
        </span>
      </div>
      <div className="gleiwitz-andere-blogs">
        <h2 className="gleiwitz-lees-ook">
          <span>Lees ook:</span>
          <br></br>
        </h2>
        <div className="gleiwitz-laatste3-blogposts"></div>
      </div>
      <Footer rootClassName="footerroot-class-name20"></Footer>
    </div>
  )
}

export default Gleiwitz
